module.exports = __webpack_public_path__ + "static/img/logo-szechenyi_2020.2e281f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-szechenyi_2020.png
// module id = 3gFy
// module chunks = 1